export type Languages = 'en' | 'fr';
export type LanguagesUpper = 'EN' | 'FR';

export const supportedLanguages: Languages[] = ['en', 'fr'];
export const defaultLanguage: Languages = 'en';
export const defaultLanguageUpper: LanguagesUpper = 'EN';
